<template>
  <div class="">
    <col-skeleton-loader v-if="loading" :clms="6"></col-skeleton-loader>
    <v-row v-else class="mt-5" width="100%">
      <v-col cols="6" v-for="clm in columns" :key="clm.title">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle
                  >{{ clm.subtitle }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{ clm.tooltip }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  {{ animalHealth[clm.title] }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import AnimalService from "@/_services/AnimalService";
import ColSkeletonLoader from "@/components/col-skeleton-loader.vue";
export default {
  created() {
    const fetchData = async () => {
      this.getAnimalHealthRecord(this.$route.params.animal_number);
    };
    fetchData();
  },
  components: {
    ColSkeletonLoader,
  },
  data() {
    return {
      loading: true,
      animalHealth: {},
      columns: [
        {
          subtitle: this.$t('animal.healthRecordInfo.treatment'),
          title: "treatment",
          tooltip: this.$t('animal.healthRecordInfo.treatmentTakenAnimal'),
        },
        {
          subtitle: this.$t('animal.healthRecordInfo.reasonOfTreatment'),
          title: "treatmentReason",
          tooltip: this.$t('animal.healthRecordInfo.whatReasonOfTreatment'),
        },
        {
          subtitle: this.$t('animal.healthRecordInfo.treatmentDate'),
          title: "treatmentDate",
          tooltip: this.$t('animal.healthRecordInfo.dateOfTreatment'),
        },
        {
          subtitle: this.$t('animal.healthRecordInfo.diagnosis'),
          title: "diagnosis",
          tooltip: this.$t('animal.healthRecordInfo.nameDiagnosedDiseaseConditionSymptoms'),
        },
        {
          subtitle: this.$t('animal.healthRecordInfo.drugID'),
          title: "drugId",
          tooltip: this.$t('animal.healthRecordInfo.iDOfDrugWhichIsGivenToAnimal'),
        },
        {
          subtitle: this.$t('animal.healthRecordInfo.drugName'),
          title: "drugName",
          tooltip: this.$t('animal.healthRecordInfo.nameDrugAnimal'),
        },
        {
          subtitle: this.$t('animal.healthRecordInfo.drugWithdrawalPeriod'),
          title: "drugWithdrawPeriod",
          tooltip:
            this.$t('animal.healthRecordInfo.timeAdministrationDrugAnimalMeatMilkHumanConsumption'),
        },
        {
          subtitle: this.$t('animal.healthRecordInfo.attendingVeterinarian'),
          title: "attendingVeterinarian",
          tooltip: this.$t('animal.healthRecordInfo.qualifiedPersonCaseAnimal'),
        },
        {
          subtitle: this.$t('animal.healthRecordInfo.packID'),
          title: "packId",
          tooltip: this.$t('animal.healthRecordInfo.iDPackTreatment'),
        },
      ],
    };
  },
  methods: {
    getAnimalHealthRecord(animalId) {
      AnimalService.getAnimalHealthRecord(animalId)
        .then((res) => {
          this.animalHealth = res.data.healthRecord;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>